export function buildAdvancedTemplateCallbackURL(productName: string): string {
  return `${window.location.origin}/printer/template?templateSlugFromCallback=${productName}`;
}
